import { PageCalculatorService } from './../../../base/service/page-calculator.service';
import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalService } from '@app/base/service/modal.service';
import { ConditionEnum } from '@app/base/enum/condition.enum';
import { ChangeOrganismoService } from '../service/change-organismo.service';
import { ControlService } from '@app/base/service/control.service';
import { ConditionSearchList } from '@app/base/list/condition.list';
import { GridOptions } from 'ag-grid';
import { AppConfig } from '@app/config/app.config';
import { Router } from '@angular/router';
import { LoginService } from '@app/features/login/service/login.service';
import { ErrorHandlerService } from '@app/base/service/error-handler.service';
import { LoaderUiStatic } from '@app/features/loader-ui/loader-ui.static';

@Component({
    selector: 'app-change-organismo',
    templateUrl: 'change-organismo.component.html',
})

export class ChangeOrganismoComponent implements AfterViewInit {

    @ViewChild('jwmodalref') jwModalRef;

    public modalId: string = 'changeorganismo';
    public titleSearch: string = 'Organismos';

    public desktopPagerSize = 9;
    public totalPages;
    public totalData;
    public currentPage;

    public overlayNoRowsTemplate: any;

    public modalFormGroup: FormGroup;

    public campos: any[] = [];

    public trySave: boolean;

    public currentEnum: ConditionEnum;

    public lastControlFocus: string;

    public condicoes: any[] = [];

    private onStart: boolean = true;

    public rowData = [];
    protected columnDefs = [];
    public gridOptions: GridOptions;
    public gridApi: any;

    public totalSearchPages;
    public totalSearchData;
    public searchCurrentPage;

    public desktopPaginationSize: number;
    public tabletPaginationSize: number;
    public mobilePaginationSize: number;

    protected changes: MutationObserver;

    public hasSelected: boolean = false;

    public camposCustom = [];

    public selectDisabled: boolean = true;

    constructor(
        private service: ChangeOrganismoService,
        private formBuilder: FormBuilder,
        private modalService: ModalService,
        private controlService: ControlService,
        private pageCalculatorService: PageCalculatorService,
        private router: Router,
        private loginService: LoginService,
        private errorHandlerService: ErrorHandlerService,
    ) {
        this.campos = [
            { 'id': 1, 'width': 300, 'minWidth': 90, 'maxWidth': 800, 'columnShow': 'true', 'descricao': 'Razão Social', 'field': 'razaoSocial', 'condition': ConditionEnum.String},
            { 'id': 2, 'width': 150, 'minWidth': 90, 'maxWidth': 400, 'columnShow': 'true', 'descricao': 'Cidade', 'field': 'cidade', 'condition': ConditionEnum.String},
            { 'id': 3, 'width': 150, 'minWidth': 90, 'maxWidth': 400, 'columnShow': 'true', 'descricao': 'Bairro', 'field': 'bairro', 'condition': ConditionEnum.String},
            { 'id': 4, 'width': 150, 'minWidth': 90, 'maxWidth': 400, 'columnShow': 'true', 'descricao': 'Tipo', 'field': 'tipo', 'condition': ConditionEnum.String},

        ];

        this.camposCustom = this.campos.filter((c) => c.field !== 'tipo');

        this.currentEnum = ConditionEnum.String;

        this.createForm();

        this.modalFormGroup.get('campo').valueChanges.subscribe((value) => {

            let field = this.modalFormGroup.get('campo').value;

            let result = this.campos.filter((campo) => {
                return (campo['field'] === field);
            });

            let teste = new ConditionSearchList();

            this.condicoes = teste.get(result[0]['condition']);

            this.modalFormGroup.get('condicao').setValue(teste.getDefault(result[0]['condition']));

            this.changeSearchInput(this.modalFormGroup.get('campo').value);

            this.controlService.setFocus('busca');
        });

        this.generateColumnDefs();

        this.gridOptions = <GridOptions>{
            navigateToNextCell: (params) => {
                this.myNavigation(params);
            },
            onGridReady: (params) => {
                this.onGridReady(params);
            },
            onModelUpdated: (params) => {
                this.onModelUpdated(params);
            },
            onRowSelected: (params) => {
                if (this.gridApi.getSelectedNodes().length > 0) {
                    this.selectDisabled = false;
                } else {
                    this.selectDisabled = true;
                }
            },
        };

        this.gridOptions.columnDefs = this.columnDefs;
        this.gridOptions.rowData = [];
        this.overlayNoRowsTemplate = '<span></span>';

        this.desktopPaginationSize = 10;
        this.tabletPaginationSize = 5;
        this.mobilePaginationSize = 3;

        this.changes = new MutationObserver((mutations: MutationRecord[]) => {
            mutations.forEach((mutation: MutationRecord) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {

                    let mutationTarget: any = mutation.target;

                    if (String(mutationTarget.attributes['style'].value).indexOf('block;') > -1) {
                        this.selectDisabled = true;

                        this.modalFormGroup.get('busca').setValue('');
                        this.rowData = [];

                        this.modalFormGroup.get('campo').setValue('razaoSocial');

                        this.gridOptions.api.sizeColumnsToFit();

                        this.controlService.setFocus('busca');
                    }
                }
            });
        });
    }

    onSelectionChanged() {
        if (this.gridOptions === undefined || this.gridOptions.api === undefined) {
            return false;
        }

        this.hasSelected = this.gridOptions.api.getSelectedNodes().length > 0;
    }

    select() {
        const selectedNodes = this.gridOptions.api.getSelectedNodes();
        const selectedData = selectedNodes.map((node) => node.data);

        // let loginToken = this.localStorageService.getLoginToken();

        this.service.trocarOrganismo(AppConfig.settings, selectedData[0].id, AppConfig.refreshToken).subscribe((result) => {

            this.loginService.getConfigNomenclatura(AppConfig.settings).subscribe((resultOrganismo) => {

                AppConfig.setConfiguracoesParoquia(resultOrganismo);

            });

            console.group('Troca de Organismo');
            AppConfig.setToken(result);
            console.groupEnd();

            this.router.navigate(['/']);

            let control = undefined;

            this.resetSearchState();

            this.closeModal();
        });
    }

    resetSearchState() {
        this.rowData = [];
        this.hasSelected = false;
        this.searchCurrentPage = undefined;
        this.totalSearchData = undefined;
        this.totalSearchPages = undefined;
    }

    onModelUpdated(params) {
        params.api.forEachNode((node) => {
            if (0 === node.rowIndex) {
                node.setSelected(true);
            }
        });

        params.api.setFocusedCell(0, 'razaoSocial');
    }

    onGridReady(params) {
        this.gridApi = params.api;
    }

    generateColumnDefs() {
        this.campos.forEach((campo: any) => {
            if (campo.columnShow === 'true') {
                if (campo.field === 'tipo') {
                    this.columnDefs.push({ headerName: campo.descricao, field: campo.field, width: campo.width, suppressSizeToFit: true});
                } else {
                    this.columnDefs.push({ headerName: campo.descricao, field: campo.field, width: campo.width });
                }
            }
        });
    }

    createForm() {
        this.modalFormGroup = this.formBuilder.group({
            campo: '',
            condicao: '',
            busca: '',
        });
    }

    closeModal() {
        this.modalService.close(this.modalId);
    }

    ngAfterViewInit(): void {
        this.modalFormGroup.get('busca').setValue('');

        let element = this.jwModalRef.el.nativeElement;

        this.changes.observe(element, {
            attributes: true,
            childList: true,
            characterData: true,
        });

        this.controlService.setFocus('busca');
    }

    ngOnDestroy(): void {
        if (this.changes !== undefined) {
            this.changes.disconnect();
        }
    }

    public lastFocusControlChange(controlName: string) {
		this.lastControlFocus = controlName;
    }

    private changeSearchInput(event: string ) {
        let selectedCampo = event;
        let currentCampo = this.campos.filter((x) => x.field === selectedCampo);

        if (currentCampo === undefined) {
            return;
        }

        this.currentEnum = currentCampo[0].condition;

        if (this.onStart === false) {
            this.modalFormGroup.get('busca').setValue('');
        } else {
            this.onStart = true;
        }
    }

    search() {
        LoaderUiStatic.open();
        this.service.getSearch(AppConfig.settings, this.modalFormGroup).subscribe((data: any) => {
            try {
                if (data[0] === undefined) {
                    this.rowData = [];
                    this.overlayNoRowsTemplate = '<span>Nenhum registro encontrado.</span>';
                    this.totalSearchData = undefined;
                    this.totalSearchPages = undefined;
                } else {
                    this.rowData = this.dataAdapter(data);
                    this.totalSearchData = data.totalRows;
                    this.searchCurrentPage = 1;
                    this.totalSearchPages = this.pageCalculatorService.calculate(data.totalRows);
                }
            } finally {
                LoaderUiStatic.close();
            }
        }, (error) => {
            try {
                this.errorHandlerService.handle(error);
            } finally {
                LoaderUiStatic.close();
            }
        });
    }

    dataAdapter(data) {
        return data;
    }

    myNavigation(params) {
        var KEY_UP = 38;
        var KEY_DOWN = 40;
        var KEY_LEFT = 37;
        var KEY_RIGHT = 39;

        const selectedNodes = this.gridOptions.api.getSelectedNodes();

        switch (params.key) {

            case KEY_DOWN:
                this.gridApi.forEachNode((node) => {
                    if (selectedNodes[0].rowIndex + 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return;
            case KEY_UP:
                this.gridApi.forEachNode((node) => {
                    if (selectedNodes[0].rowIndex - 1 === node.rowIndex) {
                        node.setSelected(true);
                    }
                });
                return;
            case KEY_LEFT:
            case KEY_RIGHT:
                return;
            default:
                throw 'this will never happen, navigation is always on of the 4 keys above';
        }
    }
}